import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'client-card',
  standalone: false,
  templateUrl: './client-card.component.html',
  styleUrls: ['./client-card.component.scss']
})
export class ClientCardComponent implements OnInit {
  @Input() insurer_id: string;
  @Input() clientName: string;
  @Input() policy_number: string;
  @Input() effective_date: string;
  @Input() quoteOrPolicy: string;
  constructor() { }

  ngOnInit(): void {
  }

}
